var subRouter;
subRouter = function (Main) {
  return [
  {
    path: '/kiaf/log',
    name: 'kiaflog',
    component: () => import('../src/Page/Log')
  }, {
    path: '/kiaf/version',
    name: 'kiafversion',
    component: () => import('../src/Page/Version')
  }, {
    path: '/kiaf/sso',
    name: 'KiafSSO',
    component: () => import('../src/Page/SSO')
  }, {
    path: '/kiaf/kick/online/user',
    component: Main,
    children: [
      {
        path: '',
        name: 'KiafKickOnlineUser',
        component: () => import('../src/Page/KickOnlineUser')
      }
    ]
  }, {
    path: '/kiaf/menuhome',
    component: Main,
    children: [
      {
        path: '',
        name: 'KiafMenuHome',
        component: () => import('../src/Page/MenuHome')
      }
    ]
  }, {
    path: '/kiaf/homepage',
    component: Main,
    children: [
      {
        path: '',
        name: 'KiafHomePage',
        component: () => import('../src/Page/HomePage')
      }
    ]
  }, {
    path: '/kiaf/internalPage',
    component: Main,
    children: [
      {
        path: '',
        name: 'KiafInternalPage',
        component: () => import('../src/Page/InternalPage')
      }
    ]
  }, {
    path: '/kiaf/webview',
    component: Main,
    children: [
      {
        path: '',
        name: 'KiafWebview',
        component: () => import('../src/Page/WebView')
      }
    ]
  }];
};
export default subRouter;
